import { render, staticRenderFns } from "./InputAnswer.vue?vue&type=template&id=46a5b145&scoped=true&"
import script from "./InputAnswer.vue?vue&type=script&lang=js&"
export * from "./InputAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5b145",
  null
  
)

export default component.exports